import { TabItem } from '../../../tab-bar.js';

const TabItemLink = ({ label, selected, onClick, icon, 'data-tag': dataTag, to, dataAt, altIcon, labelLive }) => (
	<TabItem
		Icon={altIcon || icon}
		key={icon}
		aria-selected={selected ? 'true' : 'false'}
		label={labelLive || label}
		onClick={onClick}
		data-tag={dataTag}
		to={to || dataTag}
		data-at={dataAt}
	/>
);

export default TabItemLink;
